/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import lottie from 'lottie-web';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        console.log( target );
        $( target ).slideToggle();
      } );

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( 'body' ).toggleClass( 'is-open' );
      } );

      // $( document ).on( 'click', '.js-init-video', function() {

      // } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).magnificPopup( {
        delegate: '.js-init-video',
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).magnificPopup( {
        delegate: '.js-init-content',
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      } );

      $( document ).magnificPopup( {
        delegate: '.js-init-interaction-content',
        type: 'inline',
        mainClass: 'mfp-fade mfp-interaction-popup',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'body' ).addClass( 'is-locked' );
          },
          close: function() {
            $( 'body' ).removeClass( 'is-locked' );
          },
        },
      } );

      $( '.interaction-popup .custom-close' ).click( function() {
        $.magnificPopup.close();
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      if ( $( '.gform_wrapper' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
          if ( $( '#input_' + formId + '_' + fieldId ).val() ) {
            const path = $( '#input_' + formId + '_' + fieldId ).val().replace( 'C:\\fakepath\\', '' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( path );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).addClass( 'has-file' );
          } else {
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( 'No file selected' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).removeClass( 'has-file' );
          }
        }, 10, 3 );
      }

      gsap.registerPlugin( ScrollTrigger );
      $( '.animation-test-wrapper' ).each( function( key, val ) {
        const animation = lottie.loadAnimation( {
          container: this,
          renderer: 'svg',
          name: 'animation-' + key,
          loop: true,
          autoplay: false,
          path: $( this ).attr( 'data-url' ),
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            end: 'bottom top',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'is-loaded' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              $( this ).addClass( 'is-loaded' );
              lottie.play( 'animation-' + key );
            },
          },
        } );
      } );

      if ( $( '.client-progress' ).length ) {
        $( '.client-progress .progress-slider' ).slick( {
          dots: false,
          arrows: true,
          prevArrow: $( '.client-progress' ).find( '.slider-prev' )[0],
          nextArrow: $( '.client-progress' ).find( '.slider-next' )[0],
          slidesToShow: 1,
          initialSlide: $( '.client-progress .progress-slider .content.initial-slide' ).index(),
          infinite: false,
        } );

        setTimeout( function() {
          const sliderPos = $( '.client-progress .progress-slider' ).offset().left;
          if ( $( '.timeline-wrapper #here-flag' ).length ) {
            const parentGroup = $( '.timeline-wrapper #here-flag' ).closest( '.parent-group' );
            $( '.timeline-wrapper' ).animate( {
              scrollLeft: ( parentGroup[0].offsetLeft - sliderPos ),
            }, 500 );
          }

          $( '.client-progress .progress-slider' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
            const parentGroup = $( $( '.client-progress .progress-slider .slick-slide:nth-child(' + ( nextSlide + 1 ) + ')' ).attr( 'data-group' ) ).closest( '.parent-group' );
            $( '.timeline-wrapper' ).animate( {
              scrollLeft: ( parentGroup[0].offsetLeft - sliderPos ),
            }, 500 );
          } );
        }, 500 );
      }

      $( '.marquee .phrases' ).each( function() {
        $( this ).slick( {
          speed: 5000,
          autoplay: true,
          autoplaySpeed: 0,
          centerMode: true,
          cssEase: 'linear',
          slidesToShow: 1,
          slidesToScroll: -1,
          variableWidth: true,
          infinite: true,
          initialSlide: $( this ).closest( '.marquee' ).attr( 'data-initial-slide' ) ? parseInt( $( this ).closest( '.marquee' ).attr( 'data-initial-slide' ) ) : 1,
          arrows: false,
          buttons: false,
          rtl: $( this ).closest( '.marquee' ).attr( 'data-direction' ) == 'right' ? true : false,
          pauseOnHover: false,
          pauseOnFocus: false,
        } );
      } );

      $( '.primary-nav' ).on( 'scroll', function( e ) {
        $( '.read-more-gradient' ).css( 'top', $( this ).scrollTop() + $( window ).height() - $( '#wpadminbar' ).height() );
        if ( $( this ).scrollTop() + $( this ).innerHeight() >= $( this )[0].scrollHeight ) {
          $( this ).addClass( 'at-end' );
        } else {
          $( this ).removeClass( 'at-end' );
        }
      } );

      $( document ).on( 'focus mouseover', '.tooltip-toggle', function() {
        $( $( this ).attr( 'data-tooltip' ) ).addClass( 'is-visible' );
      } ).on( 'blur mouseout', '.tooltip-toggle', function() {
        $( $( this ).attr( 'data-tooltip' ) ).removeClass( 'is-visible' );
      } );
    },
    finalize: function() {
      function responsiveEmbed() {
        $( '.wysiwyg iframe' ).wrap( '<div class="embed-container"></div>' );
        $( 'div.embed-container:has(iframe[name*="gform_ajax_frame_"])' ).css( 'display', 'none' );
      }
      responsiveEmbed();
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
